import * as React from 'react'

import { useSelector } from 'react-redux'

import {
  makeSelectSegmentAnalyticsMetadata,
  makeSelectUser,
} from '@webapp/core/stores/global'
import { useFeatureFlag } from '@webapp/hooks'
import { GlobalAnalytics } from './GlobalAnalytics'
import { GlobalAnalyticsDeprecated } from './GlobalAnalyticsDeprecated'

export const ConnectedGlobalAnalytics = () => {
  const user = useSelector(makeSelectUser())
  const segmentAnalyticsMetadata = useSelector(
    makeSelectSegmentAnalyticsMetadata()
  )
  const DATA_1577_GLOBAL_ANALYTICS_REFACTOR = useFeatureFlag(
    'DATA_1577_GLOBAL_ANALYTICS_REFACTOR'
  )

  const shouldRender =
    user?.id &&
    segmentAnalyticsMetadata?.group &&
    segmentAnalyticsMetadata?.user

  if (!shouldRender) {
    return null
  }

  return DATA_1577_GLOBAL_ANALYTICS_REFACTOR ? (
    <GlobalAnalytics
      user={user}
      segmentAnalyticsMetadata={segmentAnalyticsMetadata}
    />
  ) : (
    <GlobalAnalyticsDeprecated
      user={user}
      segmentAnalyticsMetadata={segmentAnalyticsMetadata}
    />
  )
}
